import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { environment } from "../../../environments/environment";
import { BehaviorSubject, Observable } from "rxjs";
import { IUserData } from "../../interfaces/administration/userData";

@Injectable({
  providedIn: "root",
})
export class UserService {
  private apiUrl = environment.apiUrl + "/users";

  private currentUserDataSubject: BehaviorSubject<IUserData> =
    new BehaviorSubject(null);
  currentUserData$: Observable<IUserData> =
    this.currentUserDataSubject.asObservable();

  constructor(private http: HttpClient) {}

  public getAllUsers(): Observable<IUserData[]> {
    const url = `${this.apiUrl}/getAll`;
    return this.http.get<IUserData[]>(url);
  }

  public getUserByEmail(email: string): Observable<IUserData> {
    return this.http.get<IUserData>(`${this.apiUrl}/getUserByEmail/${email}`);
  }

  public updateUserData(data: IUserData): void {
    this.currentUserDataSubject.next(data);
  }

  public updateUser(userData: IUserData): Observable<IUserData> {
    return this.http.put<IUserData>(`${this.apiUrl}/updateUser`, userData);
  }

  public searchForUserInEntra(searchText: String): Observable<IUserData[]> {
    const url = `${this.apiUrl}/search/${searchText}`;
    return this.http.get<IUserData[]>(url);
  }
}
